import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import LinearProgress from '@mui/material/LinearProgress';
import MuiLink from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import { useAPI, useQuery, usePagination, Row } from '@mybonus/ui';
import { useCallback, useMemo, useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

import { Page, ErrorPopup, DateTime, Paginate } from '../../components';
import { getWithdrawlReviewChipColor } from '../../helpers';

export function WithdrawalReviewListView() {
	const [searchParams, setSearchParams] = useSearchParams({ page: '1' });
	const initialPage = searchParams.get('page') ? Number(searchParams.get('page')) : 1;
	const { pagination, setPage, page } = usePagination(initialPage);
	const { api } = useAPI();

	const input = useMemo(
		() => ({
			pagination: pagination.pagination,
		}),
		[pagination, searchParams],
	);

	const list = useQuery(
		'admin.withdrawalReview.list',
		(args) => api.admin.withdrawalReview.list.query(args),
		input,
	);

	useEffect(() => {
		searchParams.set('page', `${page}`);
		setSearchParams(searchParams);
	}, [page]);

	return (
		<Page title="Withdrawal Reviews">
			<Paginate state={list.data?.pagination} setPage={setPage} />

			{list.isLoading && <LinearProgress />}

			<ErrorPopup error={list.error} onRetry={list.load} onClose={list.reset} />

			{list && (
				<TableContainer component={Paper}>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell>ID</TableCell>
								<TableCell>Status</TableCell>
								<TableCell>Amount</TableCell>
								<TableCell>User</TableCell>
								<TableCell>Handled by admin</TableCell>
								<TableCell>Created</TableCell>
								<TableCell>Updated</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{list.data?.items.map((row) => (
								<TableRow key={row.id}>
									<TableCell scope="row">
										<MuiLink component={Link} to={`/app/withdrawal-reviews/${row.id}`}>
											{row.id}
										</MuiLink>
									</TableCell>
									<TableCell scope="row">
										<Chip
											label={row.decision}
											size="small"
											color={getWithdrawlReviewChipColor(row.decision)}
										/>
									</TableCell>
									<TableCell>{row.amount.text}</TableCell>
									<TableCell>
										<MuiLink component={Link} to={`/app/users/${row.user.id}`}>
											{row.user.email}
										</MuiLink>{' '}
										({row.user.id})
									</TableCell>
									<TableCell>{row.handledByAdmin?.email || '-'}</TableCell>
									<TableCell>
										<DateTime date={row.updatedAt} />
									</TableCell>
									<TableCell>
										<DateTime date={row.createdAt} />
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			)}
			<Grid container direction="row" justifyContent="flex-end">
				<Paginate state={list.data?.pagination} setPage={setPage} />
			</Grid>
		</Page>
	);
}
